export const filesRules = [
    (v: File[]) => v.length > 0 || 'Поле обязательно',
    (v: File[]) => (v.find((file) => file.name === 'table_urls.xlsx') !== undefined)  || 'Отсутствует файл table_urls.xlsx',
  ];
